import {z} from "zod";

import {getOrCreateWebDeviceId} from "../lib/device-id";
import {loginSchema} from "../schemas";
import {LoginRequest} from "../types";

function withWebDeviceIdentity(
  payload: Omit<LoginRequest, "device_id" | "platform">,
): LoginRequest {
  return {
    ...payload,
    device_id: getOrCreateWebDeviceId(),
    platform: "web",
  };
}

class AuthSerializer {
  serializeLogin(data: z.infer<typeof loginSchema>): LoginRequest {
    return withWebDeviceIdentity({
      ...data,
      remember_me: data.remember_me ? 1 : 0,
    });
  }

  serializeToken(token: string): LoginRequest {
    return withWebDeviceIdentity({
      token,
      remember_me: 0,
    });
  }
}

export const authSerializer = new AuthSerializer();
